import React from "react";
import { useSuppressionListView } from "../SuppressionList.context";
import { SortOption } from "./SuppressionListFilter.types";

export function useSuppressionListFilter() {
  const {
    audiences,
    enableBulkDelete,
    enableSelectionActions,
    isSuppressionDeletable,
    isItemSelected,
    nrOfSelectedSuppressions,
    onDeleteSuppressions,
    reloadSuppressionList,
    searchKeyword,
    selectItem,
    selectionDisabled,
    setSearchKeyword,
    setSortOption,
    sortOption,
    sortOptions,
    unselectAll,
    unselectItem,
  } = useSuppressionListView();

  const [findEmailDialogOpen, setFindEmailDialogOpen] = React.useState(false);

  const openFindEmailDialog = React.useCallback(() => {
    setFindEmailDialogOpen(true);
  }, []);

  const onCloseFindEmailDialog = React.useCallback(() => {
    setFindEmailDialogOpen(false);
  }, []);

  const onChangeSort = React.useCallback(
    (e: any, item: SortOption) => {
      setSortOption(item);
    },
    [setSortOption]
  );

  const selectedText = React.useMemo(
    () => `${nrOfSelectedSuppressions} selected`,
    [nrOfSelectedSuppressions]
  );

  const hasSelected = React.useMemo(
    () => nrOfSelectedSuppressions > 0,
    [nrOfSelectedSuppressions]
  );

  const availablesForSelect = React.useCallback(() => {
    return (
      audiences?.content?.filter((item) =>
        enableBulkDelete ? isSuppressionDeletable(item) : true
      ) || []
    );
  }, [audiences?.content, enableBulkDelete, isSuppressionDeletable]);

  const areAllSelectedOnCurrentPage = React.useMemo(() => {
    const availableForSelect = availablesForSelect();
    return (
      availableForSelect.length > 0 &&
      availableForSelect.filter(isItemSelected).length ===
        availableForSelect.length
    );
  }, [availablesForSelect, isItemSelected]);

  const toggleAllOnCurrentPage = React.useCallback(() => {
    const availableForSelect = availablesForSelect();
    availableForSelect.forEach(
      areAllSelectedOnCurrentPage ? unselectItem : selectItem
    );
  }, [
    areAllSelectedOnCurrentPage,
    availablesForSelect,
    selectItem,
    unselectItem,
  ]);

  const checkAllDisabled = React.useMemo(() => {
    const availables = availablesForSelect();
    return availables.length === 0 || selectionDisabled;
  }, [availablesForSelect, selectionDisabled]);

  return {
    areAllSelectedOnCurrentPage,
    checkAllDisabled,
    enableBulkDelete,
    enableSelectionActions,
    findEmailDialogOpen,
    hasSelected,
    onChangeSort,
    onCloseFindEmailDialog,
    onDeleteSuppressions,
    openFindEmailDialog,
    reloadSuppressionList,
    searchKeyword,
    selectedText,
    selectionDisabled,
    setSearchKeyword,
    sortOptions,
    sortedBy: sortOption.value,
    toggleAllOnCurrentPage,
    unselectAll,
  };
}
